import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './QueryResultTable.css';
export function parseValue(value) {
    if (typeof value === 'boolean') {
        return String(value).toUpperCase();
    }
    if (typeof value === 'object') {
        return JSON.stringify(value);
    }
    return value;
}
function QueryResultTable({ data, highlightErrorRows = [], isSolutionSubmission = false, tableClassName = '', }) {
    if (typeof data === 'number') {
        return _jsx("div", { className: "ResultsTable__container", children: data });
    }
    const isErrorRow = (rowIndex) => (highlightErrorRows === null || highlightErrorRows === void 0 ? void 0 : highlightErrorRows.indexOf(rowIndex)) !== -1;
    const rowClassName = (rowIndex) => {
        if (!isSolutionSubmission)
            return '';
        return isErrorRow(rowIndex) ? 'wrong' : 'correct';
    };
    return (_jsxs("table", { className: `table-bordered table-striped fixed-width strata-editor-result-table table ${tableClassName}`, children: [_jsx("thead", { children: _jsx("tr", { children: data === null || data === void 0 ? void 0 : data.columns.map((col) => (_jsx("th", { children: col }, `${col}-header`))) }) }), _jsx("tbody", { id: "myTable", children: data === null || data === void 0 ? void 0 : data.data.map((row, i) => (
                // eslint-disable-next-line react/no-array-index-key
                _jsx("tr", { className: rowClassName(i), children: row.map((cell, j) => (
                    // eslint-disable-next-line react/no-array-index-key
                    _jsx("td", { children: parseValue(cell) }, `cell-${i}-${parseValue(cell)}-${j}`))) }, `row-${i}-${row.join()}`))) })] }));
}
export default QueryResultTable;
//# sourceMappingURL=QueryResultTable.js.map